import React, { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { isEmpty } from 'lodash'
import { useAccountId, useGetAllUsers } from '@labrav/common'
import { useDispatch, useSelector } from '../../../store'
import { getCurrentReceivedResaleAuthorization } from '../../../modules/receivedResellerAuthorization/action'
import { ViewDetailsResellerAuthorization } from '../ViewDetailsResellerAuthorization/ViewDetailsResellerAuthorization'
import { getCurrencySymbol } from '../../../common/utils/getCurrencySymbol'
import { useSyncFlyoutRouteParams } from '../../../common/utils/hooks/useSyncFlyoutRouteParams'
import type { ViewReceivedResellerAuthorizationProps } from '../types'

export type { ViewReceivedResellerAuthorizationProps }

export const ViewReceivedResellerAuthorization: React.FC<
  ViewReceivedResellerAuthorizationProps
> = ({ crmOpportunityId }) => {
  const { users } = useGetAllUsers()

  useSyncFlyoutRouteParams()

  const dispatch = useDispatch()
  const { accountId: routeAccountId } = useParams<{
    cloud: string
    accountId: string
  }>()
  const fallbackAccountId = useAccountId({ product: 'flyout' }) || ''
  const accountId = routeAccountId || fallbackAccountId
  const { resaleAuthorizationId: resaleAuthorizationIdParam } = useParams<{
    productId?: string
    resaleAuthorizationId: string
  }>()
  const resaleAuthorizationId = resaleAuthorizationIdParam as string

  const { cloud: routeCloud } = useParams<{ cloud: string }>()
  const navigate = useNavigate()
  useEffect(() => {
    if (routeCloud && routeAccountId && routeCloud.toLowerCase() !== 'aws') {
      navigate(
        `/flyout/aws/${routeAccountId}/resale-authorizations/received/${resaleAuthorizationId}/details`,
        { replace: true }
      )
    }
  }, [routeCloud, routeAccountId, resaleAuthorizationId, navigate])

  const { receivedResaleAuthorization } = useSelector(state => {
    const receivedResaleAuthorization =
      state.receivedResellerAuthorization.currentReceivedResellerAuthorizations[
        resaleAuthorizationId
      ]

    return {
      receivedResaleAuthorization,
    }
  })
  const currencySymbol = getCurrencySymbol(
    receivedResaleAuthorization?.currency as string
  )

  useEffect(() => {
    if (!isEmpty(accountId)) {
      {
        dispatch(
          getCurrentReceivedResaleAuthorization(
            accountId,
            resaleAuthorizationId,
            crmOpportunityId
          )
        )
      }
    }
  }, [accountId, resaleAuthorizationId, crmOpportunityId])

  return isEmpty(receivedResaleAuthorization) ? (
    <div data-testid="empty-reseller-authorization"></div>
  ) : (
    <>
      <div data-testid="received-reseller-authorization">
        <ViewDetailsResellerAuthorization
          resellerAuthorization={receivedResaleAuthorization}
          cloudMarketplace="AWS"
          currencySymbol={currencySymbol}
          users={users}
        />
      </div>
    </>
  )
}
